export default class ProductFinder {
	constructor($wrapper)
	{
		this.$wrapper = $wrapper;
		this.slider = $wrapper.find('#volumeSlider');
		this.resultsLoaded = false;
		this.data = [];
		this.baseResults = [];
		this.remainingOptions = {
			'category': 0,
			'sectionControl': 0,
			'sliderOperation': 0,
			'boundarySpreading': 0
		};

		this.init();
		this.purposeChanged();
		this.inputOrSliderChanged();

		// Load results
		if ($wrapper.find('#results').length) {
			this._getFinderResults();
		}
	}

	init()
	{
		let purpose = this.$wrapper.find('.purpose input:checked').val();
		this._filterWorkingWidth(purpose);
		// Hide filter options
		this.$wrapper.find('.filterOptions').hide();
		this.$wrapper.find('.spinner').html('<p>' + this.$wrapper.data('loading') + '</p>');

		// Event listener for further/fewer options button
		this.$wrapper.find('#toggleFilterOptions').on('click', e => {
			e.preventDefault();
			this.$wrapper.find('.filterOptions').toggle();
			this.$wrapper.find('.filterOptions > .row').attr('data-equalizer', 'filterOptions');
			new Foundation.Equalizer(this.$wrapper.find('.filterOptions .row[data-equalizer]')).applyHeight();
			this.$wrapper.find('#toggleFilterOptions').toggleClass('filtered');
		});
		// Event listender for reset options button
		this.$wrapper.find('#resetOptions').on('click', e => {
			e.preventDefault();
			this.resetOptions()
		});
	}

	resetOptions()
	{
		// Resets the form to default state or the state taken from "mini finder" (homepage)
		this.$wrapper.find('form')[0].reset();
		let purpose = this.$wrapper.find('.purpose input:checked').val();
		this._filterWorkingWidth(purpose);
		// There could be selected options from "mini finder" (homepage) - reset them
		this.clearAllCheckboxes();
		this._changeVolumeSlider(purpose);
	}

	purposeChanged()
	{
		this.$wrapper.find('.purpose input').on('click', e => {
			let selectedPurpose = $(e.target).val();
			this._filterWorkingWidth(selectedPurpose);
			this.clearAllCheckboxes();
			this._changeVolumeSlider(selectedPurpose);
		});
	}

	inputOrSliderChanged()
	{
		// Input has changed (except purpose, here we need to wait on the slider update)
		this.$wrapper.find('input:not(#purpose1):not(#purpose2):not(#purpose3)').on('change', e => {
			this.applyFilters();
		});
		// Slider has changed
		this.slider.on('changed.zf.slider', e => {
			this.applyFilters();
		});
	}

	applyFilters()
	{
		if (this.resultsLoaded) {
			this.$wrapper.addClass('loading');
			this.applyBaseFilters();
			this.countValues();

			setTimeout(() => {
				this.$wrapper.removeClass('loading');
			}, 500);
		}
	}

	/**
	 * Base filters = purpose, working width and min/max volume
	 */
	applyBaseFilters()
	{
		let purpose = this.$wrapper.find('.purpose input:checked').val();
		let workingWidths = this.$wrapper.find('.workingWidth input:checked').map(function(){
			return this.value;
		}).get();
		let volume = this.$wrapper.find('#volume').val();
		let maxVolume = this.$wrapper.find('#maxVolume').val();

		// Filter output
		this.baseResults = this.data.filter(variant => {
			return (
				variant.purposes.find(el => {return el == purpose}) &&
				variant.minWorkingWidth <= Math.min.apply(Math, workingWidths) &&
				variant.maxWorkingWidth >= Math.max.apply(Math, workingWidths) &&
				variant.volume <= maxVolume &&
				variant.maxVolume >= volume
			);
		});
	}

	countValues()
	{
		// Initialize count variables
		let categoryCount = {
			increment(val) {
				typeof this[val] === "undefined" ? this[val] = 1 : this[val]++;
			}
		};
		let sliderOperationsCount = {
			increment(val) {
				typeof this[val] === "undefined" ? this[val] = 1 : this[val]++;
			}
		};
		let sectionControlCount = {
			increment(val) {
				typeof this[val] === "undefined" ? this[val] = 1 : this[val]++;
			}
		};
		let boundarySpreadingCount = {
			increment(val) {
				typeof this[val] === "undefined" ? this[val] = 1 : this[val]++;
			}
		};

		// Get selected options
		let isobus = this.$wrapper.find('#isobus').is(':checked');
		let residualQuantityWeighingSystemW = this.$wrapper.find('#residualQuantityWeighingSystemW').is(':checked');
		let variableRateControl = this.$wrapper.find('#variableRateControl').is(':checked');

		// All of this options can contain multiple values
		let categories = this.$wrapper.find('.row.category input:checked').map(function(){
			return this.value;
		}).get();
		let sectionControl = this.$wrapper.find('.row.sectionControl input:checked').map(function(){
			return this.value;
		}).get();
		let sliderOperation = this.$wrapper.find('.row.sliderOperation input:checked').map(function(){
			return this.value;
		}).get();
		let boundarySpreading = this.$wrapper.find('.row.boundarySpreading input:checked').map(function(){
			return this.value;
		}).get();

		/* Temporary results
		 * To count values we need the variants filtered by all options except the option we want to count
		 */
		// tmpBase = variants filtered by boolean values
		let tmpBase = this.baseResults.filter(variant => {
			return (isobus && variant.isobus != isobus) ||
			(residualQuantityWeighingSystemW && variant.residualQuantityWeighingSystemW != residualQuantityWeighingSystemW) ||
			(variableRateControl && variant.variableRateControl != variableRateControl) ? false : true;
		});
		// categoryVariants - filter by sectionControl, sliderOperation and boundarySpreading
		let categoryVariants = tmpBase.filter(variant => {
			return (sectionControl.length > 0 && !sectionControl.find(el => {return el == variant.sectionControl})) ||
			(sliderOperation.length > 0 &&
				!sliderOperation.find(el => {return variant.sliderOperations.find(
					variantSliderOperation => {return variantSliderOperation == el}
				)})
			) || (boundarySpreading.length > 0 &&
				!boundarySpreading.find(el => {return variant.boundarySpreading.find(
					variantBoundarySpreading => {return variantBoundarySpreading == el}
				)})
			) ? false : true;
		});
		// sectionControlVariants - filter by categories, sliderOperation and boundarySpreading
		let sectionControlVariants = tmpBase.filter(variant => {
			return (categories.length > 0 && !categories.find(el => {return el == variant.category})) ||
			(sliderOperation.length > 0 &&
				!sliderOperation.find(el => {return variant.sliderOperations.find(
					variantSliderOperation => {return variantSliderOperation == el}
				)})
			) || (boundarySpreading.length > 0 &&
				!boundarySpreading.find(el => {return variant.boundarySpreading.find(
					variantBoundarySpreading => {return variantBoundarySpreading == el}
				)})
			) ? false : true;
		});
		// sliderOperationVariants - filter by categories, sectionControl and boundarySpreading
		let sliderOperationVariants = tmpBase.filter(variant => {
			return (categories.length > 0 && !categories.find(el => {return el == variant.category})) ||
			(sectionControl.length > 0 && !sectionControl.find(el => {return el == variant.sectionControl})) ||
			(boundarySpreading.length > 0 &&
				!boundarySpreading.find(el => {return variant.boundarySpreading.find(
					variantBoundarySpreading => {return variantBoundarySpreading == el}
				)})
			) ? false : true;
		});
		// boundarySpreadingVariants - filter by categories, sectionControl and sliderOperation
		let boundarySpreadingVariants = tmpBase.filter(variant => {
			return (categories.length > 0 && !categories.find(el => {return el == variant.category})) ||
			(sectionControl.length > 0 && !sectionControl.find(el => {return el == variant.sectionControl})) ||
			(sliderOperation.length > 0 &&
				!sliderOperation.find(el => {return variant.sliderOperations.find(
					variantSliderOperation => {return variantSliderOperation == el}
				)})
			) ? false : true;
		});

		// Category and section control are N:1 relations
		categoryVariants.forEach(variant => {
			categoryCount.increment(variant.category);
		});
		sectionControlVariants.forEach(variant => {
			sectionControlCount.increment(variant.sectionControl);
		});
		// Slider operations and boundary spreading are N:M relations
		sliderOperationVariants.forEach(variant => {
			variant.sliderOperations.forEach(sliderOperation => {
				sliderOperationsCount.increment(sliderOperation);
			});
		});
		boundarySpreadingVariants.forEach(variant => {
			variant.boundarySpreading.forEach(boundarySpreading => {
				boundarySpreadingCount.increment(boundarySpreading);
			});
		});

		// Filter categoryVariants by checked categories and get final results
		let results = categoryVariants.filter(variant => {
			return (categories.length > 0 && !categories.find(el => {return el == variant.category})) ? false : true;
		});

		let isobusCount = 0;
		let residualQuantityWeighingSystemWCount = 0;
		let variableRateControlCount = 0;
		results.forEach(variant => {
			if (variant.isobus) {
				isobusCount++;
			}
			if (variant.residualQuantityWeighingSystemW) {
				residualQuantityWeighingSystemWCount++;
			}
			if (variant.variableRateControl) {
				variableRateControlCount++;
			}
		});

		// Boolean values
		if (isobusCount > 0) {
			this.$wrapper.find('.booleanValues .isobus').show();
			this.$wrapper.find('.isobus label .count').html(this.countWrap(isobusCount));
		} else {
			this.$wrapper.find('.booleanValues .isobus').hide();
			this.$wrapper.find('#isobus').prop('checked', false);
		}
		if (residualQuantityWeighingSystemWCount > 0) {
			this.$wrapper.find('.booleanValues .residualQuantityWeighingSystemW').show();
			this.$wrapper.find('.residualQuantityWeighingSystemW label .count').html(this.countWrap(residualQuantityWeighingSystemWCount));
		} else {
			this.$wrapper.find('.booleanValues .residualQuantityWeighingSystemW').hide();
			this.$wrapper.find('#residualQuantityWeighingSystemW').prop('checked', false);
		}
		if (variableRateControlCount > 0) {
			this.$wrapper.find('.booleanValues .variableRateControl').show();
			this.$wrapper.find('.variableRateControl label .count').html(this.countWrap(variableRateControlCount));
		} else {
			this.$wrapper.find('.booleanValues .variableRateControl').hide();
			this.$wrapper.find('#variableRateControl').prop('checked', false);
		}

		let allHidden = true;
		this.remainingOptions['category'] = 0;
		this.$wrapper.find('.row.category .column').each((index, element) => {
			let tmpInput = $(element).find('input[type="checkbox"]');
			let tmpCount = categoryCount[tmpInput.val()];
			if (tmpCount > 0) {
				$(element).show();
				$(element).find('label .count').html(this.countWrap(tmpCount));
				this.remainingOptions['category']++;
			} else {
				$(element).hide();
				tmpInput.prop('checked', false);
			}
		});
		if (this.remainingOptions['category'] === 0) {
			this.$wrapper.find('.row.category').hide();
		} else {
			this.$wrapper.find('.row.category').show();
			allHidden = false;
		}

		this.remainingOptions['sectionControl'] = 0;
		this.$wrapper.find('.row.sectionControl .column').each((index, element) => {
			let tmpInput = $(element).find('input[type="checkbox"]');
			let tmpCount = sectionControlCount[tmpInput.val()];
			if (tmpCount > 0) {
				$(element).show();
				$(element).find('label .count').html(this.countWrap(tmpCount));
				this.remainingOptions['sectionControl']++;
			} else {
				$(element).hide();
				tmpInput.prop('checked', false);
			}
		});
		if (this.remainingOptions['sectionControl'] === 0) {
			this.$wrapper.find('.row.sectionControl').hide();
		} else {
			this.$wrapper.find('.row.sectionControl').show();
			allHidden = false;
		}

		this.remainingOptions['sliderOperation'] = 0;
		this.$wrapper.find('.row.sliderOperation .column').each((index, element) => {
			let tmpInput = $(element).find('input[type="checkbox"]');
			let tmpCount = sliderOperationsCount[tmpInput.val()];
			if (tmpCount > 0) {
				$(element).show();
				$(element).find('label .count').html(this.countWrap(tmpCount));
				this.remainingOptions['sliderOperation']++;
			} else {
				$(element).hide();
				tmpInput.prop('checked', false);
			}
		});
		if (this.remainingOptions['sliderOperation'] === 0) {
			this.$wrapper.find('.row.sliderOperation').hide();
		} else {
			this.$wrapper.find('.row.sliderOperation').show();
			allHidden = false;
		}

		this.remainingOptions['boundarySpreading'] = 0;
		this.$wrapper.find('.row.boundarySpreading .column').each((index, element) => {
			let tmpInput = $(element).find('input[type="checkbox"]');
			let tmpCount = boundarySpreadingCount[tmpInput.val()];
			if (tmpCount > 0) {
				$(element).show();
				$(element).find('label .count').html(this.countWrap(tmpCount));
				this.remainingOptions['boundarySpreading']++;
			} else {
				$(element).hide();
				tmpInput.prop('checked', false);
			}
		});
		if (this.remainingOptions['boundarySpreading'] === 0) {
			this.$wrapper.find('.row.boundarySpreading').hide();
		} else {
			this.$wrapper.find('.row.boundarySpreading').show();
			allHidden = false;
		}

		if (allHidden) {
			this.$wrapper.find('#toggleFilterOptions').hide();
		} else {
			this.$wrapper.find('#toggleFilterOptions').show();
		}

		this.outputResults(results);
	}

	countWrap(count)
	{
		return `&nbsp;[&nbsp;${count}&nbsp;]`;
	}

	/**
	 * Get all model variants
	 * typeNum is defined in setup.typoscript
	 *
	 * @private
	 */
	_getFinderResults()
	{
		this.$wrapper.addClass('loading');
		$.ajax({
			type: 'GET',
			dataType: 'json',
			url: this.$wrapper.data('base') + '?type=3715',
			success: (response) => {
				this.data = response;
				this.resultsLoaded = true;
				this.applyFilters();
				this.$wrapper.removeClass('loading');
			}
		});
	}

	outputResults(results)
	{
		this.outputResultCount(results.length);
		const output = results.reduce((prev, curr) => prev += curr.teaser, '');

		$('#results').html(
			'<div class="row xsmall-up-2 xmedium-up-3 xlarge-up-4 xxlarge-up-6" data-equalizer="productfinder" data-equalize-by-row="true">' +
			output +
			'</div>'
		);

		new Foundation.Equalizer($('#results [data-equalizer="productfinder"]')).applyHeight()
	}

	outputResultCount(resultCount)
	{
		let postfix = $('#resultCount').data('results');
		if (resultCount == 1) {
			postfix = $('#resultCount').data('result');
		}
		$('#resultCount').html(resultCount + ' ' + postfix);
	}

	/**
	 * Filter workingWidth checkboxes to match current purpose selection
	 *
	 * @param purpose
	 * @private
	 * @return void
	 */
	_filterWorkingWidth(purpose)
	{
		this.$wrapper.find('.workingWidth > div').hide();
		// Uncheck all checkboxes not matching current purpose - important to keep working width settings from start page
		this.$wrapper.find('.workingWidth > div:not(.p' + purpose + ') input').prop('checked', false);
		this.$wrapper.find('.workingWidth > div.p' + purpose).show();
	}

	clearAllCheckboxes()
	{
		// Uncheck all checkboxes
		this.$wrapper.find('input[type="checkbox"]').prop('checked', false);
	}

	/**
	 * Change volume slider to match current purpose selection
	 * typeNum is defined in setup.typoscript
	 *
	 * @param purpose
	 * @private
	 */
	_changeVolumeSlider(purpose)
	{
		$.ajax({
			type: 'GET',
			dataType: 'json',
			url: this.$wrapper.data('base') + '?type=3710&purpose=' + purpose,
			success: response => {
				new Foundation.Slider(this.slider, response);
				this.applyFilters();
			}
		});
	}
}
